module.exports = __webpack_public_path__ + "img/shadow_ios_zh.cce1880.png";